<template>
  <div>
    <div class="d-flex h-100 align-center justify-center">
      <div class="px-4">
        Redirecting...
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

require('@/plugins/TabsManager')
require('@/sockets/socket')
require('@/sockets/on-premise-signal-socket')
require('@/plugins/OcularAnalitycs')
require('@/plugins/MediaDevices')
require('@/services/UuidGenerator')

@Component({
  computed: {
    widget () {
      return this.$store.state.widget
    },
    state () {
      return this.$store.state.storage.state
    },
    streaming () {
      return this.$store.state.rooms.item.data
    },
    streamingPlayer () {
      return this.$organization.streamingPlayer()
    },
    formIsMain () {
      return this.$organization.formIsMain()
    },
    linkSession () {
      return this.$store.state.linkSession
    }
  }
})
export default class Index extends Vue {
  mounted () {
    setTimeout(() => {
      this.start()
    }, 100)
  }

  start () {
    if (this.$organization.detectCammerAvailability().isActive) {
      this.$socketEvents.connectListen()
    }

    if (this.streaming._id && this.streamingPlayer.isActive) {
      this.$router.replace({ path: `/rooms/${this.streaming._id}`, query: { fromLink: true } })
    } else if (this.widget.isBusy === true) {
      this.$router.replace({ path: '/is-busy' })
    } else if (this.state.id === 2 && this.linkSession?.id) {
      this.$router.replace({ path: '/calling' })
    } else if (this.state.id === 3) {
      this.$router.replace({ path: '/queue' })
    } else if (this.state.id === 4) {
      const path = this.$organization.totemMode().isActive ? '/call' : '/room'
      this.$router.replace({ path })
    } else if (this.state.id === 5) {
      this.$router.replace({ path: '/calification' })
    } else if (this.state.id === 6) {
      this.$router.replace({ path: '/questions' })
    } else if (this.$organization.totemMode().isActive) {
      this.$router.replace({ path: '/totem' })
    } else if (this.formIsMain.isActive) {
      this.ocGoogleAnalyticsInit()
      this.$store.state.widget.mainPath = '/home'
      this.$router.replace({ path: '/home' })
    } else {
      this.ocGoogleAnalyticsInit()
      this.nextRoute()
      this.$storage.setState(1)
    }
  }

  nextRoute () {
    if (!this.$organization.smartMode()) {
      this.$store.state.widget.mainPath = '/categories'
      this.$router.replace({ path: '/categories' })
    } else if (this.$organization.calendaryModule() && this.$organization.directCallModule()) {
      this.$store.state.widget.mainPath = '/attention-types'
      this.$router.replace({ path: '/attention-types' })
    } else if (!this.formIsMain.isActive) {
      this.$store.state.widget.mainPath = '/home'
      this.$router.replace({ path: '/home' })
    } else if (this.$organization.calendaryModule()) {
      this.$router.replace({ path: '/calendar', query: { requestChannel: true } })
    } else {
      this.$router.replace({ path: '/permissions', query: { requestChannel: true }  }).catch((error) => {})
    }
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }
}
</script>
